export default class ClientWebservice {
	constructor(complement=null) {
		this.url = '/clients-webservice' + (complement || '');
	}
}



// WEBPACK FOOTER //
// ./src/services/ClientWebService.js